import React from "react"

const H1 = ({ children }) => {
  return (
    <div className="H1">
      <h1> {children} </h1>
      <div className="subtitle-line"> </div>
    </div>
  )
}

export default H1
